import React from 'react';
import styled from 'styled-components';

const SmallSpinnerIcon = ({ className, color }) => {
  return (
    <LoadingBar className={className}>
      <SpinnerIcon data-testid="spinner-icon" color={color} />
    </LoadingBar>
  );
};

export default SmallSpinnerIcon;

const LoadingBar = styled.div`
  animation: loading-bar-spinner 800ms linear infinite;

  @keyframes loading-bar-spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const SpinnerIcon = styled.div`
  border: solid 2px transparent;
  border-left-color: ${({ color }) => color || 'inherit'};
  border-radius: ${({ theme }) => theme.radiuses.XXL};
  border-top-color: ${({ color }) => color || 'inherit'};
  height: 12px;
  width: 12px;
`;
